import { components, DropdownIndicatorProps, GroupBase } from "react-select";
import React from "react";
import Icon from "../../../../../../components/Icon";

const { DropdownIndicator } = components;

export function CustomDropdownIndicator<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: DropdownIndicatorProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};

  return (
    <span data-testid={`${testIdKey}_field_dropdown_indicator`}>
      <DropdownIndicator {...props}>
        <Icon name="chevron-down" />
      </DropdownIndicator>
    </span>
  );
}
